import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="min-h-[60vh] flex items-center justify-center px-6 py-20">
      <div className="max-w-md text-center flex flex-col items-center gap-6">
        <span className="font-display text-8xl text-warm-taupe font-light">404</span>
        <h1 className="font-display text-3xl md:text-4xl text-warm-dark">Siden blev ikke fundet</h1>
        <p className="text-sm text-warm-gray leading-relaxed">
          Beklager, men den side du leder efter findes ikke eller er blevet flyttet. Du kan altid vende tilbage til forsiden.
        </p>
        <Link
          to="/"
          className="mt-4 px-8 py-3 bg-warm-dark text-warm-light text-sm font-medium tracking-wide rounded-full hover:bg-warm-gray transition-all-custom shadow-sm"
        >
          Gå til forsiden
        </Link>
      </div>
    </main>
  );
}
